import _get from 'lodash/get';
import * as Sift from '@sift/types';

function isFieldTextCollection(field: Sift.Field) {
  return field.type === 'collection' && _get(field, 'item.type') === 'text';
}

export default isFieldTextCollection;
